import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { setStorageNamespace } from "@/lib/openPlayStore";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    async function run() {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google", {}, { headers: { "X-Session-ID": sessionId } });
        if (data?.user_id) setStorageNamespace(data.user_id);
        setUser(data);
        const back = window.location.pathname;
        const target = back && !["/", "/login"].includes(back) ? back : "/dashboard";
        window.history.replaceState({}, document.title, target);
        navigate(target, { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    }
    run();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center cyber-grid gap-4" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-primary-c" />
      <p className="text-sm mono" style={{ color: "var(--text-2)" }}>
        {error || "Establishing secure session…"}
      </p>
    </div>
  );
}
